import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';


const debounce = (callback, delay) => {
    let tid;
    return function (...args) {
        const ctx = this;
        tid && clearTimeout(tid);
        tid = setTimeout(() => {
            callback.apply(ctx, args);
        }, delay);
    };
};

const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
        callback = debounce(callback, 20);
        super(callback);
    }
};

const app = createApp(App);
app.use(ElementPlus); // Use Element Plus globally
app.mount('#app')
